import StoredLayout from '../../layouts/StoredLayout'
import Validation from './Validation'
export default StoredLayout(Validation)



// WEBPACK FOOTER //
// ./src/forms/validation/index.js